export default "__VITE_ASSET__DxgfFCxZ__"